import React, { Component } from "react";
import { connect } from "react-redux";
// import Drag from '../../campaign/dragNdDropKycFile';
import Drag from "./dragNdDrop";
import {
  postServerDataWithPath,
  putServerDataWithPath,
} from "../../../action/common_action";
import "react-datepicker/dist/react-datepicker.css";

import { ANY_ERROR, AUDIO } from "../../../action/user_action_types";
import { endPoints } from "../../../config";
import { element } from "prop-types";

class AudioRequestDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      adminInfo: JSON.parse(localStorage.getItem("adminInfo")),
      audio_file: null,
      audio_files: [],
      audio_duration: 0,
    };
  }

  //Upload a file
  getUploadedFile = (files) => {
    let sizes = files.map((e) => {
      return e.size;
    });
    sizes = [...new Set(Array.from(sizes))];
    if (sizes.length > 1) {
      alert("Please select the audios in same duration");
      return;
    }
    console.log(files);
    this.setState({ audio_files: files });
    this.getAudioDuration(files[0]);
  };

  //Remove file
  removeFile = () => {
    console.log(this.props);
    this.setState({
      audio_files: [],
    });
  };

  getAudioDuration = (file) => {
    var reader = new FileReader();
    let audioDuration = 0;
    reader.onload = () => {
      var audio = new Audio(reader.result);
      audio.onloadedmetadata = async () => {
        audioDuration = Math.floor(audio.duration);
        if (
          this.props.campaignDetails.audioLength < Math.floor(audio.duration) &&
          this.props.campaignDetails.audioLength !== Math.floor(audio.duration)
        ) {
          this.removeFile();
          alert("Audio length is more than the requested Audio length");
          return;
        } else {
          if (
            this.props.campaignDetails.audioLength >
              Math.floor(audio.duration) &&
            this.props.campaignDetails.audioLength !==
              Math.floor(audio.duration)
          ) {
            alert("Uploaded Audio is less than the requested Audio length");
          }
          this.setState({
            audio_duration: parseInt(Math.floor(audio.duration)),
          });
        }
      };
      console.log(audioDuration);
    };
    reader.readAsDataURL(file);
  };

  uploadAudioFile = async (e) => {
    e.preventDefault();
    console.log("Uploading Audio");
    console.log(this.props);
    let { audio_files } = this.state;
    let { campaignDetails } = this.props;

    let formData = new FormData();
    audio_files.forEach((element, i) => {
      formData.append(`audio${i}`, element);
    });
    formData.append("fileName", audio_files[0].name);
    formData.append("fileSize", audio_files[0].size);
    formData.append("audioDuration", this.state.audio_duration.toFixed(0));
    formData.append("_id", campaignDetails._id);
    formData.append("uploadedby", this.state.adminInfo.email);
    // formData.append('audiostatuschangedby', this.state.adminInfo.email);
    formData.append("audioStatus", "Uploaded");
    console.log("formData");
    console.log(formData);
    console.log(formData.get("fileName"));
    await this.props.updateAudioToCampaign(
      endPoints.updateCampaignAudio,
      formData,
      "/admin/audioRequestManagement"
    );
    // alert('Audio Duration - '+ this.state.audio_duration);
    this.props.callCurrentPage()
    this.props.hideUploadAudio()
  };

  render() {
    let { audio_files, campaignData } = this.state;
    return (
      <div>
        <div className="modal-overlay">
          <div
            className="modal-wrapper thankyou-popup"
            aria-modal
            aria-hidden
            tabIndex={-1}
            role="dialog"
          >
            <div className="modal" style={{width:"600px"}}>
              <div className="modal-head-cross rate-modal">
                <button
                  type="button"
                  className="modal-close-button"
                  onClick={() => this.props.hideUploadAudio()}
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <div className="editNonFct-header modal-header">
                  <h4 className="popup-head rqst-head fct-head modal-title">
                    Upload Audio File
                  </h4>
                </div>
                <div className="editNonFct-modal modal-body">
                  <div className="bg-white">
                    <form className="form-group">
                      <div className="popupCampaign-container">
                        <div className="campaign-input master-inputs nonFct">
                          <div className="lenght_file_wrapper">
                            <div className="flie_audio">
                              {audio_files.length == 0 && (
                                <div className="drag_nd_drp">
                                  <h6>Audio File</h6>
                                  <Drag
                                    getUploadedFile={this.getUploadedFile}
                                  />
                                </div>
                              )}

                              {audio_files.length > 0 && (
                                <div className="upload_file">
                                  <h6>Uploaded Audio File</h6>
                                  <div>
                                    <div className="audio_img">
                                      {" "}
                                      <img src="../../assets/images/text.svg" />
                                    </div>
                                    <div className="file_desc">
                                      <div className="file_name_size">
                                        <div className="file_name">
                                          {audio_files.length > 0 && audio_files.map((audio)=>{
                                            return <div>{audio.path}</div>
                                          })}
                                        </div>
                                      </div>
                                      <div style={{marginTop:"10px"}}
                                        className="remove_file"
                                        onClick={this.removeFile}
                                      >
                                        <a>REMOVE FILE(s)</a>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                        <div className="create-camp nonfct-submit">
                          <button onClick={this.uploadAudioFile}>Upload</button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    showError: (error) =>
      dispatch({
        type: ANY_ERROR,
        payload: error,
      }),
    updateAudioToCampaign: (url, data, path) =>
      dispatch(postServerDataWithPath(url, data, path)),
  };
};

export default connect(null, mapDispatchToProps)(AudioRequestDetails);



// WEBPACK FOOTER //
// ./web/components/admin/audioadminmanagment/AudioRequestDetails.js